<template>
  <el-table-column
    prop="target_storage.name"
    label="Átvevő raktár"
    show-overflow-tooltip
    min-width="200"
    sortable="custom"
  >
    <template slot-scope="scope">
      {{ scope.row.target_storage_name }}
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'target_storage.name',
  };
</script>
